import { usePermissoesOutletContext } from '@/pages/Permissoes.context'
import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useParams } from 'react-router-dom'
import {
    PerfilPermissao,
    permissoes,
    updatePerfilPermissaoSchema,
} from 'service/api'
import { toast } from 'sonner'
import FormPerfilPermissao from '../forms/FormPerfilPermissao'

export default function EditarPerfilPermissao() {
    const { id } = useParams()
    const { data } = usePermissoesOutletContext()
    const item = data.find(i => i.id === Number(id))
    const { mutateAsync, isLoading } = permissoes.mutations.useUpdate({
        invalidateQuery: true,
    })

    if (!item) return null

    async function handleSubmit(data: PerfilPermissao) {
        return mutateAsync(
            { ...data, id: Number(id) },
            {
                onSuccess: () => {
                    toast.success('Permissão alterada com sucesso!')
                },
                onError: err => {
                    toast.error(err.message)
                },
            },
        )
    }

    return (
        <Dialog.Root
            onSubmit={handleSubmit}
            loading={isLoading}
            schema={updatePerfilPermissaoSchema}
            defaultValues={{
                ...item,
                appAbilities: item.ModuloPermissao.map(m => [
                    (['create', 'read', 'update', 'delete'] as const).filter(
                        a => m[a],
                    ),
                    m.subject,
                ]),
            }}
            open={hasPermission(['update', 'Permissões'])}
        >
            <Dialog.Title action="Editar perfil de permissões">
                {item.nome}
            </Dialog.Title>
            <Dialog.Content>
                <FormPerfilPermissao />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
